import styled, { keyframes, css } from 'styled-components';

import { ULLY_MOBILE_BREAKPOINT } from './constants';

const PRIMARY = '#000FFF';
const SECONDARY = '#00FFFF';
const SURFACE = '#F7F7FD';
const TEXT = '#000000';

const mobile = `@media (max-width: ${ULLY_MOBILE_BREAKPOINT}px)`;

export const Overlay = styled.div`
  box-sizing: border-box;
  position: fixed;
  inset: 0;
  z-index: 1000000000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.5);
  overflow-y: auto;

  ${mobile} {
    align-items: flex-end;
    padding: 0;
  }
`;

export const LauncherWrapper = styled.div`
  &[hidden] {
    display: none;
  }

  display: flex;
  justify-content: center;
  position: fixed;
  right: 0;
  bottom: 0;
  width: 120px;
  height: 120px;
  margin: 10px;
  z-index: 999;

  @media screen and (max-width: 450px) {
    width: 100px;
    height: 100px;
  }
`;

export const LauncherButton = styled.button`
  height: 100%;
  padding: 0;
  border: 0;
  background: transparent;
`;

export const LauncherAvatar = styled.img`
  display: block;
  width: auto;
  height: 100%;
`;

export const LauncherDismiss = styled.button`
  position: absolute;
  top: 3px;
  right: 3px;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 23px;
  height: 23px;
  padding: 0;
  border: 2px solid #fff;
  border-radius: 50%;
  background-color: #00efff;
  font-family: Arial, sans-serif;
  font-size: 13px;
  font-weight: bold;
  color: #fff;
`;

export const Panel = styled.div`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  isolation: isolate;
  width: 520px;
  max-width: 100%;
  padding: 24px 0 20px;
  background: #ffffff;
  border-radius: 24px;
  font-family: 'Mangueira', sans-serif;
  color: ${TEXT};

  ${mobile} {
    width: 100%;
    padding: 24px 20px 48px;
    border-radius: 24px 24px 0 0;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  right: -23px;
  top: -22px;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  padding: 0;
  border: 0;
  border-radius: 100px;
  background: ${PRIMARY};
  color: ${SECONDARY};

  ${mobile} {
    right: 15px;
    top: -24px;
  }
`;

export const PanelContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
  z-index: 1;
`;

export const HeadingArea = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 5px;
  width: 100%;
  padding: 0 32px 24px 40px;
  border-bottom: 1px solid rgba(0, 15, 255, 0.12);

  ${mobile} {
    padding: 0 0 8px;
    border-bottom: 0;
  }
`;

export const HeadingTitle = styled.h2`
  width: 100%;
  margin: 0;
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  text-align: center;
  color: ${TEXT};

  ${mobile} {
    font-size: 20px;
  }
`;

export const HeadingText = styled.p`
  width: 100%;
  margin: 0;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: ${TEXT};
`;

export const Body = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  padding: 0 20px;

  ${mobile} {
    padding: 0;
  }
`;

export const DesktopBlock = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;
  border-radius: 24px;
`;

export const BlockTitle = styled.p`
  width: 100%;
  margin: 0;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  text-align: center;
  color: ${TEXT};
`;

export const OutlinedButton = styled.button`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  height: 48px;
  padding: 12px 20px;
  background: #ffffff;
  border: 1px solid ${PRIMARY};
  border-radius: 117px;
  color: ${PRIMARY};
  font-family: inherit;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  transition: background 0.2s ease;

  &:hover,
  &:focus-visible {
    background: rgba(0, 15, 255, 0.06);
  }
`;

export const QrCard = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 24px;
  width: 100%;
  padding: 24px;
  background: ${SURFACE};
  border-radius: 24px;

  ${mobile} {
    flex-direction: column;
  }
`;

export const QrTexts = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex-grow: 1;
  max-width: 328px;
`;

export const QrTitle = styled.p`
  width: 100%;
  margin: 0;
  font-weight: 700;
  font-size: 18px;
  line-height: 20px;
  color: ${TEXT};
`;

export const QrText = styled.p`
  width: 100%;
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${TEXT};
`;

export const PhoneLink = styled.a`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${PRIMARY};
  text-decoration: underline;

  &:hover {
    color: ${PRIMARY};
  }
`;

export const QrBox = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 136px;
  height: 136px;
  padding: 12px;
  background: #ffffff;
  border-radius: 16px;

  canvas {
    display: block;
    width: 112px;
    height: 112px;
  }
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const RING_THICKNESS = 5.66;

export const Loader = styled.div`
  position: relative;
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background: conic-gradient(
    from 90deg at 50% 50%,
    rgba(0, 15, 255, 0) 0deg,
    ${PRIMARY} 360deg
  );
  -webkit-mask: radial-gradient(
    farthest-side,
    transparent calc(100% - ${RING_THICKNESS}px),
    #000 calc(100% - ${RING_THICKNESS}px)
  );
  mask: radial-gradient(
    farthest-side,
    transparent calc(100% - ${RING_THICKNESS}px),
    #000 calc(100% - ${RING_THICKNESS}px)
  );
  animation: ${spin} 1s linear infinite;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: calc(50% - ${RING_THICKNESS / 2}px);
    width: ${RING_THICKNESS}px;
    height: ${RING_THICKNESS}px;
    border-radius: 50%;
    background: ${PRIMARY};
  }

  @media (prefers-reduced-motion: reduce) {
    animation-duration: 3s;
  }
`;

export const RedirectContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
`;

export const RedirectTexts = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const RedirectTitle = styled.h2`
  width: 100%;
  margin: 0;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: ${TEXT};
`;

export const RedirectText = styled.p`
  width: 100%;
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${TEXT};
`;

export const RedirectFallback = styled.p`
  width: 100%;
  margin: 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${PRIMARY};

  a {
    color: ${PRIMARY};
    font-weight: 700;
    text-decoration: underline;
  }
`;

export const VisuallyHidden = styled.span`
  ${css`
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  `}
`;
